export default __webpack_public_path__ + "static/media/createBlank.27e889a1.svg";